export default{
    "footer.copyright" : "Powered by Spordle ©{year} Spordle Inc. All rights reserved.",
    "footer.privacy"   : "Privacy",
    "footer.terms"     : "Terms & conditions",
    "footer.sitemap"   : "Sitemap",
    "footer.adminBtn"  : "HCR Admin",
}